<template>
	<div>
		<ul class="title7">
			<li class="L"><h1>关联推荐</h1></li>
			<li class="M"></li>
		</ul>
		<ul  class="list1"  >
			<li v-for="(item,index) in relatedata" style="display: inline-block;">
				<router-link :to="{ name: 'detail', params: { id: item.id }, query:{ source: source,s:'s' }}" target="_blank" style="white-space:normal;">{{item.title}}</router-link>
			</li>
			<!-- <li><a href=""  >国常会决定带量采购“提速扩面”，高值医用耗材纳入集采成趋势高值医用耗材纳入集采成趋势</a></li>
			<li><a href=""  >多地密集发布重大项目，新基建与新能源成为重要增长点</a></li>
			<li><a href=""  >IMF警示脆弱新兴经济体：即刻为潜在的经济动荡做准备</a></li>
			<li><a href=""  >刘和平：拜登对华科技战转向“精准脱钩”</a></li> -->
		</ul>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				
			}
		},
		props:[
			'relatedata',
			'source'
		],
	}
</script>

<style>
</style>
